// Noble Hound — theme.js
document.addEventListener('DOMContentLoaded', function () {

  // ---------- Altezza header: serve all'hero a schermo intero ----------
  // Misura barra annunci + header e la passa al CSS, così l'hero riempie
  // esattamente lo schermo rimanente senza lasciare bande vuote.
  function setHeaderHeight() {
    var bar = document.querySelector('.announcement-bar');
    var head = document.querySelector('.site-header');
    var h = 0;
    if (bar) h += bar.offsetHeight;
    if (head) h += head.offsetHeight;
    if (h > 0) document.documentElement.style.setProperty('--header-h', h + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);

  // ---------- Hero slideshow ----------
  document.querySelectorAll('.hero-slider').forEach(function (slider) {
    var slides = slider.querySelectorAll('.hero-slide');
    if (slides.length < 2) return;

    var dots = slider.querySelectorAll('.hero-slider__dot');
    var prev = slider.querySelector('.hero-slider__arrow--prev');
    var next = slider.querySelector('.hero-slider__arrow--next');
    var pauseBtn = slider.querySelector('.hero-slider__pause');

    var current = 0;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = slider.dataset.autoplay === 'true' && !reduceMotion;
    var interval = parseInt(slider.dataset.interval, 10) || 6000;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var active = i === current;
        s.classList.toggle('is-active', active);
        if (active) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
        // i link fuori dalla slide attiva non devono essere raggiungibili col tab
        s.querySelectorAll('a').forEach(function (a) { a.tabIndex = active ? 0 : -1; });
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (next) next.addEventListener('click', function () { show(current + 1); start(); });
    if (prev) prev.addEventListener('click', function () { show(current - 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.index, 10)); start(); });
    });

    // Pausa / riprendi
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        var playing = pauseBtn.dataset.playing === 'true';
        if (playing) {
          stop();
          autoplay = false;
          pauseBtn.dataset.playing = 'false';
          pauseBtn.setAttribute('aria-label', 'Riprendi la presentazione');
          pauseBtn.querySelector('.icon-pause').style.display = 'none';
          pauseBtn.querySelector('.icon-play').style.display = 'block';
        } else {
          autoplay = true;
          pauseBtn.dataset.playing = 'true';
          pauseBtn.setAttribute('aria-label', 'Metti in pausa la presentazione');
          pauseBtn.querySelector('.icon-pause').style.display = 'block';
          pauseBtn.querySelector('.icon-play').style.display = 'none';
          start();
        }
      });
    }

    // Ferma l'autoplay quando il mouse è sopra o si naviga con la tastiera
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', function () { if (autoplay) start(); });
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', function () { if (autoplay) start(); });

    // Frecce da tastiera
    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(current - 1); start(); }
      if (e.key === 'ArrowRight') { show(current + 1); start(); }
    });

    // Swipe su mobile
    var startX = null;
    slider.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) { show(dx < 0 ? current + 1 : current - 1); }
      startX = null;
      if (autoplay) start();
    }, { passive: true });

    // Non far girare le slide se la scheda è in background
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (autoplay) { start(); }
    });

    show(0);
    start();
  });

  // ---------- FAQ e accordion prodotto ----------
  document.querySelectorAll('.faq-q, .acc-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item, .acc-item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Menu mobile
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Chiudi menu' : 'Apri menu');
    });
  }

  // ---------- Carosello foto prodotto ----------
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('.product-gallery__slide');
    if (slides.length < 2) return;

    var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
    var prev = gallery.querySelector('.product-gallery__arrow--prev');
    var next = gallery.querySelector('.product-gallery__arrow--next');
    var counter = gallery.querySelector('[data-counter]');
    var current = 0;

    function show(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var active = n === current;
        s.classList.toggle('is-active', active);
        if (active) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === current);
        t.setAttribute('aria-selected', n === current ? 'true' : 'false');
      });
      if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
    }

    if (next) next.addEventListener('click', function () { show(current + 1); });
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.thumb, 10)); });
    });

    // Frecce da tastiera
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
    });

    // Swipe su telefono
    var startX = null;
    var stage = gallery.querySelector('.product-gallery__stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) { show(dx < 0 ? current + 1 : current - 1); }
        startX = null;
      }, { passive: true });
    }

    show(0);
  });

  // Selettore varianti: aggiorna id variante e prezzo
  var form = document.querySelector('.product-form');
  if (form) {
    var variantsEl = form.querySelector('[data-variants]');
    var idInput = form.querySelector('[data-variant-id]');
    var selects = form.querySelectorAll('select[data-option-index]');
    if (variantsEl && idInput && selects.length) {
      var variants = JSON.parse(variantsEl.textContent);

      // Etichette bottoni: impostabili da Personalizza → Bottoni e testi
      var lblEl = form.querySelector('[data-labels]');
      var lblSoldEl = form.querySelector('[data-labels-sold]');
      var labelAdd = lblEl ? JSON.parse(lblEl.textContent) : 'Aggiungi al carrello';
      var labelSold = lblSoldEl ? JSON.parse(lblSoldEl.textContent) : 'Esaurito';

      function syncVariant() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) {
          return chosen.every(function (val, i) { return v.options[i] === val; });
        });
        var btn = form.querySelector('button[type="submit"]');
        if (match) {
          idInput.value = match.id;
          if (btn) {
            btn.disabled = !match.available;
            btn.textContent = match.available ? labelAdd : labelSold;
          }
          // Aggiorna il prezzo solo se è mostrato (interruttore attivo nel tema)
          var priceEl = document.querySelector('.product-page__price');
          if (priceEl && match.price != null) {
            var euros = (match.price / 100).toFixed(2).replace('.', ',');
            var out = '\u20AC' + euros;
            if (match.compare_at_price && match.compare_at_price > match.price) {
              var cmp = (match.compare_at_price / 100).toFixed(2).replace('.', ',');
              priceEl.innerHTML = '<span class="price--compare">\u20AC' + cmp +
                                  '</span><span class="price--sale">' + out + '</span>';
            } else {
              priceEl.textContent = out;
            }
          }
        } else if (btn) {
          btn.disabled = true;
          btn.textContent = labelSold;
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', syncVariant); });
    }
  }
});
